import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { HelpBlock, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

export default class CrossChannelDiscountInput extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.props.onChange(e.target.value);
  }

  render() {
    return (
      <FormGroup>
        <ControlLabel>Cross Channel Discounting</ControlLabel>
        <FormControl
          type='number'
          min='0'
          max='1'
          step='0.05'
          value={this.props.value}
          className='secondary-input'
          onChange={this.onChange}
        />
        <HelpBlock>Additional discount from impressions received by a target in other modes. Zero
          means impact of an impression in one mode is not affected by impressions in other modes.
          Default setting represents a normally accepted value.
        </HelpBlock>
      </FormGroup>
    );
  }
}

CrossChannelDiscountInput.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
};
